import classnames from 'classnames';
import React from 'react';

export default function CommunicationError({ className, message, onClick }) {
  return (
    <span className={classnames('communicationError', className)} onClick={onClick}>
      <span className="communicationError-message">{message}</span>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/communication_error.jsx